/**
 * Adjectives & adverbs: the word, type what it means.
 *
 * The plainest of the three translation apps — no article, no conjugation.
 * The only thing worth showing is `usage`, and only when it is *not* "both":
 * `schnell` being fast and quickly is the unremarkable case, while `heute`
 * being adverb-only is the fact worth having.
 */
import { TypeTranslationCardFront } from '@/components/practice/TypeTranslationCard';
import type { AdjectivePayload } from '@/core/types';

import type { CardFrontProps } from '../types';

export function CardFront({ card, onAnswer }: CardFrontProps<AdjectivePayload>) {
  return (
    <TypeTranslationCardFront
      card={card}
      onAnswer={onAnswer}
      headword={card.de}
      subtitle={card.payload.usage === 'both' ? null : card.payload.usage}
    />
  );
}
